import { c as _c } from "react/compiler-runtime";
// Third Party
import * as React from 'react';
import ReactDOM from 'react-dom';
import dayjs from '@utils/dayjs-setup';
// import { Fragment } from 'react'
import { Transition, TransitionChild } from '@headlessui/react';

// Utils
import { routes } from '@routes';
import { labels, zIndex } from '@utils/constants';
import { useSearch } from '@contexts/search-context';
import { guestDescription } from '@utils/guest-description';
import { extractFirstPhraseBeforeComma } from '@utils/extract-first-phrase-before-comma';
import { isSSR } from '@utils/predicates';
// ListingsSearchType import removed — search is always geo-only (Map)

// UI
import { PlacesSelectAutocomplete, PlacesSelectAutocompleteFilters } from '@components/places-select-autocomplete';
import { ButtonIcon } from '@components/button-icon';
import { IconNames } from '@components/icon';
import { Input } from '@components/form/input';
import { Button } from '@components/button';
import { Dropdown } from '@components/dropdown';
import { Typography } from '@components/typography';
import { SearchDateRangePicker, type FocusedInputShape, type SearchDateRange } from '@components/search-date-range-picker';
import { guestCapacity } from '@utils/constants/guest-capacity-thresholds';
type Props = {
  place?: string;
};
export const NavSearchForm: React.FC<Props> = t0 => {
  const $ = _c(154);
  const {
    place: _place
  } = t0;
  const {
    searchNavFormActive,
    deactivateSearchNavForm,
    placeId,
    mapZoom,
    checkInDate: _checkInDate,
    checkOutDate: _checkOutDate,
    adultCount: _adultCount,
    childCount: _childCount,
    infantCount: _infantCount,
    petCount: _petCount,
    activeFilters,
    mapViewportManuallyChanged
  } = useSearch();
  const t1 = placeId ? placeId : "";
  const t2 = _place ? _place : "";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = {
      id: t1,
      name: t2
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [place, setPlace] = React.useState(t3);
  const [placeError, setPlaceError] = React.useState(false);
  const [adultCount, setAdultCount] = React.useState(_adultCount);
  const [childCount, setChildCount] = React.useState(_childCount);
  const [infantCount, setInfantCount] = React.useState(_infantCount);
  const [petCount, setPetCount] = React.useState(_petCount);
  const [checkInDate, setCheckIn] = React.useState(_checkInDate);
  const [checkOutDate, setCheckOut] = React.useState(_checkOutDate);
  const [dateRangePickerInputElement, _setDateRangePickerInputElement] = React.useState(null);
  const [dateRangePickerFocusedInput, setDateRangePickerFocusedInput] = React.useState(null);
  const [guestCountHumanReadableValue, setGuestCountHumanReadableValue] = React.useState("");
  const [guestCountInputElement, _setGuestCountInputElement] = React.useState(null);
  const [guestCountFocusedInput, setGuestCountFocusedInput] = React.useState(false);
  let t4;
  let t5;
  if ($[3] !== adultCount || $[4] !== childCount || $[5] !== infantCount || $[6] !== petCount) {
    t4 = () => {
      const description = guestDescription(adultCount, childCount, infantCount, petCount);
      setGuestCountHumanReadableValue(description);
    };
    t5 = [adultCount, childCount, infantCount, petCount];
    $[3] = adultCount;
    $[4] = childCount;
    $[5] = infantCount;
    $[6] = petCount;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  React.useEffect(t4, t5);
  let t6;
  let t7;
  if ($[9] !== _adultCount || $[10] !== _checkInDate || $[11] !== _checkOutDate || $[12] !== _childCount || $[13] !== _infantCount || $[14] !== _petCount) {
    t6 = () => {
      const description_0 = guestDescription(_adultCount, _childCount, _infantCount, _petCount);
      setAdultCount(_adultCount);
      setChildCount(_childCount);
      setInfantCount(_infantCount);
      setPetCount(_petCount);
      setCheckIn(_checkInDate);
      setCheckOut(_checkOutDate);
      setGuestCountHumanReadableValue(description_0);
    };
    t7 = [_adultCount, _childCount, _infantCount, _petCount, _checkInDate, _checkOutDate];
    $[9] = _adultCount;
    $[10] = _checkInDate;
    $[11] = _checkOutDate;
    $[12] = _childCount;
    $[13] = _infantCount;
    $[14] = _petCount;
    $[15] = t6;
    $[16] = t7;
  } else {
    t6 = $[15];
    t7 = $[16];
  }
  React.useEffect(t6, t7);
  let t8;
  let t9;
  if ($[17] !== mapViewportManuallyChanged || $[18] !== placeId) {
    t8 = () => {
      if (!placeId || mapViewportManuallyChanged) {
        setPlace({
          id: "",
          name: "Map Search"
        });
      }
    };
    t9 = [placeId, mapViewportManuallyChanged];
    $[17] = mapViewportManuallyChanged;
    $[18] = placeId;
    $[19] = t8;
    $[20] = t9;
  } else {
    t8 = $[19];
    t9 = $[20];
  }
  React.useEffect(t8, t9);
  let t10;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = range => {
      setCheckIn(range.checkInDate);
      setCheckOut(range.checkOutDate);
    };
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const handleDatesChange = t10;
  const handleValueChange = _temp;
  let t11;
  if ($[22] !== activeFilters || $[23] !== adultCount || $[24] !== checkInDate || $[25] !== checkOutDate || $[26] !== childCount || $[27] !== infantCount || $[28] !== mapZoom || $[29] !== petCount || $[30] !== place) {
    t11 = event => {
      event.preventDefault();
      if (!place) {
        setPlaceError(true);
        return;
      }
      const queryParams = new URLSearchParams(window.location.search);
      window.location.assign(routes.searchShow({
        placeId: place.id || undefined,
        zoom: place.id ? undefined : queryParams.get("zoom") || mapZoom?.toString() || undefined,
        centerLat: place?.id ? undefined : queryParams.get("centerLat") || undefined,
        centerLng: place?.id ? undefined : queryParams.get("centerLng") || undefined,
        southWestLat: place?.id ? undefined : queryParams.get("southWestLat") || undefined,
        southWestLng: place?.id ? undefined : queryParams.get("southWestLng") || undefined,
        northEastLat: place?.id ? undefined : queryParams.get("northEastLat") || undefined,
        northEastLng: place?.id ? undefined : queryParams.get("northEastLng") || undefined,
        checkInDate: checkInDate || undefined,
        checkOutDate: checkOutDate || undefined,
        adultCount,
        childCount,
        infantCount,
        petCount,
        activeFeatures: activeFilters.map(_temp2).join(",")
      }));
    };
    $[22] = activeFilters;
    $[23] = adultCount;
    $[24] = checkInDate;
    $[25] = checkOutDate;
    $[26] = childCount;
    $[27] = infantCount;
    $[28] = mapZoom;
    $[29] = petCount;
    $[30] = place;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  const onSubmit = t11;
  let t12;
  let t13;
  if ($[32] !== searchNavFormActive) {
    t12 = () => {
      if (searchNavFormActive) {
        document.body.classList.add("modalActive", "mx-0", "overflow-hidden");
      } else {
        document.body.classList.remove("modalActive");
      }
    };
    t13 = [searchNavFormActive];
    $[32] = searchNavFormActive;
    $[33] = t12;
    $[34] = t13;
  } else {
    t12 = $[33];
    t13 = $[34];
  }
  React.useEffect(t12, t13);
  if (!isSSR) {
    let t14;
    if ($[35] !== adultCount || $[36] !== checkInDate || $[37] !== checkOutDate || $[38] !== childCount || $[39] !== dateRangePickerFocusedInput || $[40] !== dateRangePickerInputElement || $[41] !== deactivateSearchNavForm || $[42] !== guestCountFocusedInput || $[43] !== guestCountHumanReadableValue || $[44] !== guestCountInputElement || $[45] !== infantCount || $[46] !== onSubmit || $[47] !== petCount || $[48] !== place || $[49] !== placeError || $[50] !== searchNavFormActive) {
      let t15;
      if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = {
          zIndex: zIndex.navigation
        };
        $[52] = t15;
      } else {
        t15 = $[52];
      }
      let t16;
      if ($[53] !== deactivateSearchNavForm) {
        t16 = () => {
          deactivateSearchNavForm();
        };
        $[53] = deactivateSearchNavForm;
        $[54] = t16;
      } else {
        t16 = $[54];
      }
      let t17;
      if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = <div className="absolute inset-0 bg-gray-main opacity-75" />;
        $[55] = t17;
      } else {
        t17 = $[55];
      }
      let t18;
      if ($[56] !== t16) {
        t18 = <TransitionChild as="div" className="absolute flex top-0 bottom-0 w-full align-bottom" enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-300" leaveFrom="opacity-100" leaveTo="opacity-0"><div className="transition-opacity" onClick={t16}>{t17}</div></TransitionChild>;
        $[56] = t16;
        $[57] = t18;
      } else {
        t18 = $[57];
      }
      let t19;
      if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = <TransitionChild as="div" className="fixed top-0 bottom-0 flex sm:absolute align-bottom flex-shrink lg:h-[90px] 3xl:h-[110px] transform transition-all w-full place-content-center" enter="ease-out duration-300" enterFrom="scale-y-0 origin-top" enterTo="scale-y-100 origin-top" leave="ease-in duration-300" leaveFrom="scale-y-100 origin-top" leaveTo="scale-y-0 origin-top"><div className="fixed inset-0  transition-all border-b border-gray-light"><div className="absolute inset-0 bg-white " /></div></TransitionChild>;
        $[58] = t19;
      } else {
        t19 = $[58];
      }
      let t20;
      if ($[59] !== place) {
        t20 = place && place.name && place.id ? {
          label: extractFirstPhraseBeforeComma(place.name),
          value: place.id || ""
        } : null;
        $[59] = place;
        $[60] = t20;
      } else {
        t20 = $[60];
      }
      let t21;
      if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
        t21 = (_name, option) => {
          setPlaceError(false);
          if (option) {
            setPlace({
              name: option.label,
              id: option.value
            });
          }
        };
        $[61] = t21;
      } else {
        t21 = $[61];
      }
      let t22;
      if ($[62] !== placeError || $[63] !== t20) {
        t22 = <div className="pl-2 w-full flex col-span-12 lg:col-span-4 border-r-[1px] border-gray-light whitespace-nowrap rounded-l-full overflow-hidden"><PlacesSelectAutocomplete initialValue={t20} placesFilter={PlacesSelectAutocompleteFilters.REGIONS} isInvalid={placeError} showLabel={true} name="place" label="Where" labelLeftAligned={true} placeholder="" noResultsLabel={labels.noResultsFound} data-testid="@search/search-input-place" onChange={t21} hasBorder={false} /></div>;
        $[62] = placeError;
        $[63] = t20;
        $[64] = t22;
      } else {
        t22 = $[64];
      }
      let t23;
      if ($[65] !== checkInDate) {
        t23 = checkInDate ? dayjs(checkInDate).format("MMM D") : undefined;
        $[65] = checkInDate;
        $[66] = t23;
      } else {
        t23 = $[66];
      }
      let t24;
      if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
        t24 = () => {
          setDateRangePickerFocusedInput("startDate");
        };
        $[67] = t24;
      } else {
        t24 = $[67];
      }
      let t25;
      if ($[68] !== t23) {
        t25 = <Input label="Check-in" name="checkInDate" labelLeftAligned={true} value={t23} data-testid="@search/search-input-date" readOnly={true} inputClassName="text-primary-main bg-white" onClick={t24} autoComplete="off" hasBorder={false} hasCaret={false} />;
        $[68] = t23;
        $[69] = t25;
      } else {
        t25 = $[69];
      }
      const t26 = !!dateRangePickerFocusedInput;
      let t27;
      if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
        t27 = () => {
          setDateRangePickerFocusedInput(null);
        };
        $[70] = t27;
      } else {
        t27 = $[70];
      }
      let t28;
      if ($[71] !== checkInDate || $[72] !== checkOutDate || $[73] !== dateRangePickerFocusedInput) {
        t28 = <div className="px-2"><SearchDateRangePicker focusedInput={dateRangePickerFocusedInput} onFocusChange={setDateRangePickerFocusedInput} checkInDate={checkInDate} checkOutDate={checkOutDate} onDatesChange={handleDatesChange} /></div>;
        $[71] = checkInDate;
        $[72] = checkOutDate;
        $[73] = dateRangePickerFocusedInput;
        $[74] = t28;
      } else {
        t28 = $[74];
      }
      let t29;
      if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
        t29 = <div className="flex w-full justify-end pb-2 pr-2"><Button variant="text" className="bg-white" onClick={() => {
            setCheckIn(null);
            setCheckOut(null);
            setDateRangePickerFocusedInput("startDate");
          }}>Clear</Button></div>;
        $[75] = t29;
      } else {
        t29 = $[75];
      }
      let t30;
      if ($[76] !== dateRangePickerInputElement || $[77] !== t26 || $[78] !== t28) {
        t30 = <div className="absolute mt-2"><Dropdown dropdownWidth="635px" reference={dateRangePickerInputElement} isOpen={t26} onClickAway={t27} data-id="date-range-picker-dropdown" className="absolute">{t28}{t29}</Dropdown></div>;
        $[76] = dateRangePickerInputElement;
        $[77] = t26;
        $[78] = t28;
        $[79] = t30;
      } else {
        t30 = $[79];
      }
      let t31;
      if ($[80] !== t25 || $[81] !== t30) {
        t31 = <div ref={_setDateRangePickerInputElement} className="min-w-[150px] w-full lg:ml-2  border-r-[1px] border-gray-light">{t25}{t30}</div>;
        $[80] = t25;
        $[81] = t30;
        $[82] = t31;
      } else {
        t31 = $[82];
      }
      let t32;
      if ($[83] !== checkOutDate) {
        t32 = checkOutDate ? dayjs(checkOutDate).format("MMM D") : undefined;
        $[83] = checkOutDate;
        $[84] = t32;
      } else {
        t32 = $[84];
      }
      let t33;
      if ($[85] !== checkInDate) {
        t33 = () => {
          if (!checkInDate) {
            setDateRangePickerFocusedInput("startDate");
          } else {
            setDateRangePickerFocusedInput("endDate");
          }
        };
        $[85] = checkInDate;
        $[86] = t33;
      } else {
        t33 = $[86];
      }
      let t34;
      if ($[87] !== t32 || $[88] !== t33) {
        t34 = <div className="min-w-[150px] w-full ml-1 lg:ml-2  border-r-[1px] border-gray-light"><Input label="Check-out" name="checkOutDate" labelLeftAligned={true} data-testid="@search/check-out-date" value={t32} readOnly={true} inputClassName="text-primary-main bg-white" onClick={t33} autoComplete="off" hasBorder={false} hasCaret={false} /></div>;
        $[87] = t32;
        $[88] = t33;
        $[89] = t34;
      } else {
        t34 = $[89];
      }
      let t35;
      if ($[90] === Symbol.for("react.memo_cache_sentinel")) {
        t35 = {
          caretColor: "transparent",
          textOverflow: "ellipsis"
        };
        $[90] = t35;
      } else {
        t35 = $[90];
      }
      let t36;
      if ($[91] === Symbol.for("react.memo_cache_sentinel")) {
        t36 = () => {
          setGuestCountFocusedInput(true);
        };
        $[91] = t36;
      } else {
        t36 = $[91];
      }
      let t37;
      if ($[92] !== guestCountHumanReadableValue) {
        t37 = <Input style={t35} label="Who?" name="guests" labelLeftAligned={true} value={guestCountHumanReadableValue} readOnly={true} inputClassName="text-primary-main bg-white" onClick={t36} autoComplete="off" hasBorder={false} hasCaret={false} />;
        $[92] = guestCountHumanReadableValue;
        $[93] = t37;
      } else {
        t37 = $[93];
      }
      let t38;
      if ($[94] === Symbol.for("react.memo_cache_sentinel")) {
        t38 = () => {
          setGuestCountFocusedInput(false);
        };
        $[94] = t38;
      } else {
        t38 = $[94];
      }
      let t39;
      if ($[95] === Symbol.for("react.memo_cache_sentinel")) {
        t39 = <div className="flex flex-col"><Typography variant="subtitle2" component="p">Adults</Typography><Typography variant="body2" component="p">Ages 13 or above</Typography></div>;
        $[95] = t39;
      } else {
        t39 = $[95];
      }
      let t40;
      if ($[96] === Symbol.for("react.memo_cache_sentinel")) {
        t40 = <ButtonIcon icon={IconNames.MINUS} ariaDescribedby="remove-adult" ariaLabel="Remove adult" variant="text" className="text-gray-main" onClick={() => setAdultCount(_temp3)} />;
        $[96] = t40;
      } else {
        t40 = $[96];
      }
      let t41;
      if ($[97] === Symbol.for("react.memo_cache_sentinel")) {
        t41 = e_0 => {
          handleValueChange(e_0, setAdultCount, guestCapacity.ADULTS);
        };
        $[97] = t41;
      } else {
        t41 = $[97];
      }
      let t42;
      if ($[98] !== adultCount) {
        t42 = <input type="number" aria-label="Number of adults" className="w-6 text-center bg-white" value={adultCount} data-testid="@nav-search-form/adult-count" onChange={t41} />;
        $[98] = adultCount;
        $[99] = t42;
      } else {
        t42 = $[99];
      }
      let t43;
      if ($[100] === Symbol.for("react.memo_cache_sentinel")) {
        t43 = <ButtonIcon icon={IconNames.PLUS} ariaDescribedby="add-adult" ariaLabel="Add adult" variant="text" className="text-gray-main" onClick={() => setAdultCount(_temp4)} />;
        $[100] = t43;
      } else {
        t43 = $[100];
      }
      let t44;
      if ($[101] !== t42) {
        t44 = <div className="flex justify-between">{t39}<div className="flex space-x-2 justify-between">{t40}{t42}{t43}</div></div>;
        $[101] = t42;
        $[102] = t44;
      } else {
        t44 = $[102];
      }
      let t45;
      if ($[103] === Symbol.for("react.memo_cache_sentinel")) {
        t45 = <div className="flex flex-col"><Typography variant="subtitle2" component="p">Children</Typography><Typography variant="body2" component="p">Ages 2-12</Typography></div>;
        $[103] = t45;
      } else {
        t45 = $[103];
      }
      let t46;
      if ($[104] === Symbol.for("react.memo_cache_sentinel")) {
        t46 = <ButtonIcon icon={IconNames.MINUS} ariaDescribedby="remove-child" ariaLabel="Remove child" variant="text" className="text-gray-main" onClick={() => setChildCount(_temp5)} />;
        $[104] = t46;
      } else {
        t46 = $[104];
      }
      let t47;
      if ($[105] === Symbol.for("react.memo_cache_sentinel")) {
        t47 = e_1 => {
          handleValueChange(e_1, setChildCount, guestCapacity.CHILDREN);
        };
        $[105] = t47;
      } else {
        t47 = $[105];
      }
      let t48;
      if ($[106] !== childCount) {
        t48 = <input type="number" aria-label="Number of children" className="w-6 text-center bg-white" value={childCount} data-testid="@nav-search-form/child-count" onChange={t47} />;
        $[106] = childCount;
        $[107] = t48;
      } else {
        t48 = $[107];
      }
      let t49;
      if ($[108] === Symbol.for("react.memo_cache_sentinel")) {
        t49 = <ButtonIcon icon={IconNames.PLUS} ariaDescribedby="add-child" ariaLabel="Add child" variant="text" className="text-gray-main" onClick={() => setChildCount(_temp6)} />;
        $[108] = t49;
      } else {
        t49 = $[108];
      }
      let t50;
      if ($[109] !== t48) {
        t50 = <div className="flex justify-between pt-4">{t45}<div className="flex space-x-2 justify-between">{t46}{t48}{t49}</div></div>;
        $[109] = t48;
        $[110] = t50;
      } else {
        t50 = $[110];
      }
      let t51;
      if ($[111] === Symbol.for("react.memo_cache_sentinel")) {
        t51 = <div className="flex flex-col"><Typography variant="subtitle2" component="p">Infants</Typography><Typography variant="body2" component="p">Under 2</Typography></div>;
        $[111] = t51;
      } else {
        t51 = $[111];
      }
      let t52;
      if ($[112] === Symbol.for("react.memo_cache_sentinel")) {
        t52 = <ButtonIcon icon={IconNames.MINUS} ariaDescribedby="remove-infant" ariaLabel="Remove infant" variant="text" className="text-gray-main" onClick={() => setInfantCount(_temp7)} />;
        $[112] = t52;
      } else {
        t52 = $[112];
      }
      let t53;
      if ($[113] === Symbol.for("react.memo_cache_sentinel")) {
        t53 = e_2 => {
          handleValueChange(e_2, setInfantCount, guestCapacity.INFANTS);
        };
        $[113] = t53;
      } else {
        t53 = $[113];
      }
      let t54;
      if ($[114] !== infantCount) {
        t54 = <input type="number" aria-label="Number of infants" className="w-6 text-center bg-white" value={infantCount} data-testid="@nav-search-form/infant-count" onChange={t53} />;
        $[114] = infantCount;
        $[115] = t54;
      } else {
        t54 = $[115];
      }
      let t55;
      if ($[116] === Symbol.for("react.memo_cache_sentinel")) {
        t55 = <ButtonIcon icon={IconNames.PLUS} ariaDescribedby="add-infant" ariaLabel="Add infant" variant="text" className="text-gray-main" onClick={() => setInfantCount(_temp8)} />;
        $[116] = t55;
      } else {
        t55 = $[116];
      }
      let t56;
      if ($[117] !== t54) {
        t56 = <div className="flex justify-between pt-4">{t51}<div className="flex space-x-2 justify-between">{t52}{t54}{t55}</div></div>;
        $[117] = t54;
        $[118] = t56;
      } else {
        t56 = $[118];
      }
      let t57;
      if ($[119] === Symbol.for("react.memo_cache_sentinel")) {
        t57 = <div className="flex flex-col"><Typography variant="subtitle2" component="p">Pets</Typography><Typography variant="body2" component="p">Only properties that allow</Typography><Typography variant="body2" component="p">pets will be shown</Typography></div>;
        $[119] = t57;
      } else {
        t57 = $[119];
      }
      let t58;
      if ($[120] === Symbol.for("react.memo_cache_sentinel")) {
        t58 = <ButtonIcon icon={IconNames.MINUS} ariaDescribedby="remove-pet" ariaLabel="Remove pet" variant="text" className="text-gray-main" onClick={() => setPetCount(_temp9)} />;
        $[120] = t58;
      } else {
        t58 = $[120];
      }
      let t59;
      if ($[121] === Symbol.for("react.memo_cache_sentinel")) {
        t59 = e_3 => {
          handleValueChange(e_3, setPetCount, guestCapacity.PETS);
        };
        $[121] = t59;
      } else {
        t59 = $[121];
      }
      let t60;
      if ($[122] !== petCount) {
        t60 = <input type="number" aria-label="Number of pets" className="w-6 text-center bg-white" value={petCount} data-testid="@nav-search-form/pet-count" onChange={t59} />;
        $[122] = petCount;
        $[123] = t60;
      } else {
        t60 = $[123];
      }
      let t61;
      if ($[124] === Symbol.for("react.memo_cache_sentinel")) {
        t61 = <ButtonIcon icon={IconNames.PLUS} ariaDescribedby="add-pet" ariaLabel="Add pet" variant="text" className="text-gray-main" onClick={() => setPetCount(_temp10)} />;
        $[124] = t61;
      } else {
        t61 = $[124];
      }
      let t62;
      if ($[125] !== t60) {
        t62 = <div className="flex justify-between pt-4">{t57}<div className="flex space-x-2 justify-between">{t58}{t60}{t61}</div></div>;
        $[125] = t60;
        $[126] = t62;
      } else {
        t62 = $[126];
      }
      let t63;
      if ($[127] !== guestCountFocusedInput || $[128] !== guestCountInputElement || $[129] !== t44 || $[130] !== t50 || $[131] !== t56 || $[132] !== t62) {
        t63 = <div className="absolute mt-2 right-0 xl:right-auto"><Dropdown dropdownWidth="400px" reference={guestCountInputElement} isOpen={guestCountFocusedInput} onClickAway={t38} data-id="guest-count-picker-dropdown" className="p-4 space-y-4 divide-y divide-gray-light text-left overflow-auto">{t44}{t50}{t56}{t62}</Dropdown></div>;
        $[127] = guestCountFocusedInput;
        $[128] = guestCountInputElement;
        $[129] = t44;
        $[130] = t50;
        $[131] = t56;
        $[132] = t62;
        $[133] = t63;
      } else {
        t63 = $[133];
      }
      let t64;
      if ($[134] !== t37 || $[135] !== t63) {
        t64 = <div ref={_setGuestCountInputElement} className="min-w-[200px] w-full ml-1 lg:ml-2">{t37}{t63}</div>;
        $[134] = t37;
        $[135] = t63;
        $[136] = t64;
      } else {
        t64 = $[136];
      }
      let t65;
      if ($[137] === Symbol.for("react.memo_cache_sentinel")) {
        t65 = <ButtonIcon data-testid="@filters/filters-btn" type="submit" color="primary" isCircle={true} icon={IconNames.MAGNIFYING_GLASS} iconSize="sm" className="rounded-full h-10 w-10 justify-center text-white ml-2" ariaDescribedby="search" ariaLabel="Search" />;
        $[137] = t65;
      } else {
        t65 = $[137];
      }
      let t66;
      if ($[138] !== t31 || $[139] !== t34 || $[140] !== t64) {
        t66 = <div className="flex items-center col-span-12 lg:col-span-8 whitespace-nowrap">{t31}{t34}{t64}{t65}</div>;
        $[138] = t31;
        $[139] = t34;
        $[140] = t64;
        $[141] = t66;
      } else {
        t66 = $[141];
      }
      let t67;
      if ($[142] !== t22 || $[143] !== t66) {
        t67 = <div className="grid grid-cols-12 gap-2 lg:gap-0">{t22}{t66}</div>;
        $[142] = t22;
        $[143] = t66;
        $[144] = t67;
      } else {
        t67 = $[144];
      }
      let t68;
      if ($[145] !== onSubmit || $[146] !== t67) {
        t68 = <TransitionChild as="div" className="fixed mt-4 top-0 bottom-0 sm:absolute flex align-bottom flex-shrink lg:h-[90px] 3xl:h-[110px] transform transition-all w-full bg-clear place-content-center " role="dialog" aria-modal="true" aria-labelledby="modal-headline" enter="ease-out duration-300" enterFrom="opacity-0 translate-y-4 sm:-translate-y-[100px] sm:scale-x-[0.4] scale-y-50" enterTo="opacity-100 translate-y-0 sm:scale-x-100" leave="ease-in duration-300" leaveFrom="opacity-100 translate-y-0 sm:translate-y-4 sm:scale-x-100" leaveTo="opacity-50 -translate-y-4 sm:-translate-y-[100px] sm:scale-x-[0.4] scale-y-50"><div className="fixed bottom-8 max-w-4xl flex flex-row w-full shadow-sm rounded-full px-[11px] py-[7px] bg-white text-black font-medium text-md space-x-1 border-[1px] border-gray-light flex-shrink whitespace-nowrap items-center"><form onSubmit={onSubmit}>{t67}</form></div></TransitionChild>;
        $[145] = onSubmit;
        $[146] = t67;
        $[147] = t68;
      } else {
        t68 = $[147];
      }
      let t69;
      if ($[148] !== t18 || $[149] !== t68) {
        t69 = <div className="hidden items-end justify-center text-center sm:block pt-2 h-full max-h-[1024px]">{t18}{t19}{t68}</div>;
        $[148] = t18;
        $[149] = t68;
        $[150] = t69;
      } else {
        t69 = $[150];
      }
      let t70;
      if ($[151] !== searchNavFormActive || $[152] !== t69) {
        t70 = <Transition show={searchNavFormActive} as="div" className="fixed inset-0 top-[72px] h-screen" style={t15}>{t69}</Transition>;
        $[151] = searchNavFormActive;
        $[152] = t69;
        $[153] = t70;
      } else {
        t70 = $[153];
      }
      t14 = ReactDOM.createPortal(t70, document.getElementById("modal-root") as Element);
      $[35] = adultCount;
      $[36] = checkInDate;
      $[37] = checkOutDate;
      $[38] = childCount;
      $[39] = dateRangePickerFocusedInput;
      $[40] = dateRangePickerInputElement;
      $[41] = deactivateSearchNavForm;
      $[42] = guestCountFocusedInput;
      $[43] = guestCountHumanReadableValue;
      $[44] = guestCountInputElement;
      $[45] = infantCount;
      $[46] = onSubmit;
      $[47] = petCount;
      $[48] = place;
      $[49] = placeError;
      $[50] = searchNavFormActive;
      $[51] = t14;
    } else {
      t14 = $[51];
    }
    return t14;
  } else {
    return null;
  }
};
function _temp(e, setValue, maxValue) {
  e.preventDefault();
  const re = /^[0-9\b]+$/;
  if (e.target.value.startsWith("0")) {
    e.target.value = e.target.value.slice(1);
  }
  if (e.target.value === "" || re.test(e.target.value)) {
    const inputValue = Number(e.target.value);
    const value = inputValue > maxValue ? maxValue : inputValue;
    setValue(value);
  }
}
function _temp2(f) {
  return f.key;
}
function _temp3(val) {
  if (val > 1) {
    return val - 1;
  } else {
    return val;
  }
}
function _temp4(val_0) {
  return val_0 >= guestCapacity.ADULTS ? guestCapacity.ADULTS : val_0 + 1;
}
function _temp5(val_1) {
  if (val_1 > 0) {
    return val_1 - 1;
  } else {
    return val_1;
  }
}
function _temp6(val_2) {
  return val_2 >= guestCapacity.CHILDREN ? guestCapacity.CHILDREN : val_2 + 1;
}
function _temp7(val_3) {
  if (val_3 > 0) {
    return val_3 - 1;
  } else {
    return val_3;
  }
}
function _temp8(val_4) {
  return val_4 >= guestCapacity.INFANTS ? guestCapacity.INFANTS : val_4 + 1;
}
function _temp9(val_5) {
  if (val_5 > 0) {
    return val_5 - 1;
  } else {
    return val_5;
  }
}
function _temp10(val_6) {
  return val_6 >= guestCapacity.PETS ? guestCapacity.PETS : val_6 + 1;
}